module.exports = __webpack_public_path__ + "img/contribution1.d525e152.png";